import React from 'react';

import { FieldProps, Field } from 'formik';
import { useTranslation } from 'react-i18next';

interface EmailInputProps {
  label?: string;
  name?: string;
  placeholder?: string;
  error: string | undefined;
  touched: boolean | undefined;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const EmailInput = ({
  error,
  name,
  label,
  placeholder,
  touched,
  required,
  className,
  ...props
}: EmailInputProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={`form-group${className ? ` ${className}` : ''}`}>
      <label htmlFor="emailField">
        {label || t('general.email.label')}
        {required && (
          <span className="text-danger" aria-hidden="true">
            {' '}
            *
          </span>
        )}
      </label>
      <Field name={name || 'email'}>
        {({ field }: FieldProps): JSX.Element => (
          <input
            {...field}
            {...props}
            id={name ? `${name}Field` : 'emailField'}
            type="email"
            placeholder={placeholder || t('general.email.placeholder')}
            className={`form-control ${touched && error ? 'is-invalid' : ''}`}
            data-test="emailField"
            aria-required={required}
            aria-invalid={!!(touched && error)}
            aria-describedby="emailFieldError"
          />
        )}
      </Field>
      <div className="invalid-feedback" id="emailFieldError">
        {touched && error}
      </div>
    </div>
  );
};

export default EmailInput;
